import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Input, Button } from '../../components/common';
import './UserWallet.css';

export default function UserWallet() {
  const navigate = useNavigate();
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletSerial] = useState('89457230');
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  // Exact same token helper as UserHome.js[file:3]
  const getToken = () => {
    return localStorage.getItem('authToken') || localStorage.getItem('token') || localStorage.getItem('jwt_token');
  };

  // Fetch live wallet data - exact same as UserHome.js[file:3]
  const fetchUserData = async () => {
    try {
      const token = getToken();
      console.log('🔑 Wallet token:', token ? `${token.slice(0, 20)}...` : 'NO TOKEN');
      if (!token) throw new Error('No token found');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/v1/user/home`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('✅ Wallet Data:', response.data);
      setWalletBalance(response.data.balance || 0);  // Matches backend IResult.balance[file:1][file:3]
      setError('');
    } catch (err) {
      console.error('❌ Wallet fetch error:', {
        status: err.response?.status,
        message: err.message,
        data: err.response?.data
      });
      setError(err.response?.data?.error || err.response?.data?.message || 'Failed to load wallet balance');
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  fetchUserData();
  
  // Load Cashfree SDK v3 - NEW
  const script = document.createElement('script');
  script.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
  script.async = true;
  document.body.appendChild(script);
}, []);


  const handleBack = () => {
    navigate('/home');
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleQuickAdd = (value) => {
    setAmount(value.toString());
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  if (isProcessing || !amount || parseFloat(amount) <= 0) return;
  
  const numAmount = parseFloat(amount);
  setIsProcessing(true);
  setError('');
  
  try {
    const token = getToken();
    const returnUrl = `${window.location.origin}/payment-success`;

    
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/v1/payment/userwallet/order`,
      {
        amount: numAmount,
        returnUrl,
        gateWay: 'Cashfree'  // Matches BE controller[file:7]
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    
    const { paymentSessionId } = response.data;
if (!paymentSessionId) {
  throw new Error('No payment session received');
}

console.log('✅ Payment Session ID received:', paymentSessionId);

// NEW: Cashfree SDK v3 Checkout (2025+ format)
if (typeof Cashfree === 'undefined') {
  throw new Error('Cashfree SDK not loaded. Please refresh and try again.');
}

const cashfree = Cashfree({
  mode: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox',
});

const checkoutOptions = {
  paymentSessionId: paymentSessionId,
  redirectTarget: '_self', // Redirect in same tab
};

console.log('🔄 Opening Cashfree Checkout with:', checkoutOptions);
cashfree.checkout(checkoutOptions);

    } catch (err) {
  console.error('❌ Payment initiation failed:', {
    status: err.response?.status,
    data: err.response?.data,
    message: err.message,
  });
  setError(
    err.response?.data?.message ||
    err.response?.data?.alert?.message ||
    err.message ||
    'Failed to initiate payment'
  );
} finally {

    setIsProcessing(false);
  }
};

const handleSendAmount = () => {
  if (isProcessing || !amount || parseFloat(amount) <= 0) return;
  handleSubmit({ preventDefault: () => {} });
};


  if (loading) {
    return (
      <div className="wallet-topup-root">
        <div className="wallet-topup-header">
          <div className="wallet-header-side">
            <button className="wallet-back-btn" onClick={handleBack} aria-label="Back">
              <i className="fas fa-arrow-left"></i>
            </button>
          </div>
          <div className="wallet-header-center">
            <h1 className="wallet-topup-title">Topup WALLET</h1>
          </div>
          <div className="wallet-header-side"></div>
        </div>
        <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px' }}>Loading wallet...</div>
      </div>
    );
  }

  return (
    <div className="wallet-topup-root">
      {/* Header */}
      <div className="wallet-topup-header">
        <div className="wallet-header-side">
          <button className="wallet-back-btn" onClick={handleBack} aria-label="Back">
            <i className="fas fa-arrow-left"></i>
          </button>
        </div>
        <div className="wallet-header-center">
          <h1 className="wallet-topup-title">Topup WALLET</h1>
        </div>
        <div className="wallet-header-side"></div>
      </div>

      {/* Content */}
      <div className="wallet-topup-container">
        {error && (
          <div style={{ color: 'red', textAlign: 'center', marginBottom: '20px', padding: '10px' }}>
            {error}
            <button onClick={fetchUserData} style={{ marginLeft: '10px', padding: '5px 10px' }}>Retry</button>
          </div>
        )}

        {/* Wallet Card - Live Balance */}
        <div className="wallet-card">
            <div className="wallet-card-header">
              <span 
                className="wallet-card-link" 
                onClick={() => navigate('/topup-history')} // Redirect to TopupHistory[file:4]
                style={{ cursor: 'pointer' }}
              >
                Topup History
              </span>
            </div>
          <div className="wallet-card-balance">
            Balance: <span className="wallet-balance-amount">₹{walletBalance.toFixed(2)}</span>
          </div>
          <div className="wallet-card-title">WALLET</div>
          {/* Optional: Serial No: {walletSerial} */}
        </div>

        {/* Topup Form */}
        <div className="wallet-topup-form-section">
          <label className="wallet-form-label">Add amount to topup</label>
          <form onSubmit={handleSubmit} className="wallet-topup-form">
            <div className="wallet-input-group">
              <Input
                type="number"
                placeholder="Enter amount"
                className="wallet-amount-input"
                value={amount}
                onChange={handleAmountChange}
                min="1"
                step="0.01"
                required
              />
            <button 
              type="button" 
              className="wallet-send-btn" 
              onClick={handleSendAmount} 
              disabled={isProcessing}
              aria-label="Send"
            >
              {isProcessing ? (
                <i className="fas fa-spinner fa-spin"></i>
              ) : (
                <i className="fas fa-arrow-right"></i>
              )}
            </button>
            </div>
          </form>

          {/* Quick Add Buttons */}
          <div className="wallet-quick-buttons">
            <button type="button" className="wallet-quick-btn" onClick={() => handleQuickAdd(100)}>100</button>
            <button type="button" className="wallet-quick-btn" onClick={() => handleQuickAdd(500)}>500</button>
            <button type="button" className="wallet-quick-btn" onClick={() => handleQuickAdd(1000)}>1000</button>
          </div>
        </div>
      </div>
    </div>
  );
}
